import { getFallback } from './getFallback';
import getFullUrl from './getFullUrl';
import isWebp from './isWebp';

export default (src: string) =>
  isWebp(src) ? getFallback(src) : getFullUrl(src);
